<script setup>
import LImpact from "@/components/layout/LImpact.vue";
import ImpactRoundedImg from "@/components/impact/ImpactRoundedImg.vue";
</script>

<template>
  <LImpact>
    <template #title> Transportation & Infrastructure </template>
    <template #description>
      Quantum technologies could revolutionize transportation and infrastructure by enabling faster, safer, and more efficient travel, reducing congestion and improving commute times. They will enhance the quality of public spaces, utilities, and services through better resource management. Additionally, quantum innovations could optimize logistics, ensuring the timely delivery of goods and services, boosting economic growth and access to essential products. These advancements will also support sustainable urban development, improving public safety and optimizing resource management for smarter, more resilient cities.
    </template>
    <template #image>
      <ImpactRoundedImg category-name="Transport & Infrastructure" />
    </template>
  </LImpact>
</template>

<style scoped></style>
